export const MESSAGE_PIX_TEMPLATE = `*R$100,00*
*PLANO MEGA 300GB*
%PaymentLink%
  %Pix%
    %PixCode%
      00020101021226940014BR.GOV.BCB.PIX2572...
    %/PixCode%
    %PixQrCode%
      00020101021226940014BR.GOV.BCB.PIX2572...
    %/PixQrCode%
  %/Pix%
  %BankSlip%
    12390.00004 00000.000005 00000.000006 7 45670000012350
  %/BankSlip%
  %Title%
    Plano MEGA PLUS
  %/Title%
  %Subtitle%
    Liberação imediata no pix
  %/Subtitle%
  %FooterTitle%
    MinhaEmpresa
  %/FooterTitle%
  %FooterSubtitle%
    CNPJ XX.XXX.XXX/0001-XX
  %/FooterSubtitle%
  %Price%
    R$80,90
  %/Price%
  %LogoUrl%
    https://i.imgur.com/zdcyEw7.png
  %/LogoUrl%
  %InvoiceUrl%
    https://meusite.com.br/invoice/Dc3RCoIwFAbg9
  %/InvoiceUrl%
  %Info%
    Ao efetuar o pagamento com pix a liberação é realizada imediatamente
  %/Info%
  %PrimaryColor%
    #03adec
  %/PrimaryColor%
  %Thumbnail%
    https://i.imgur.com/tBv2bfG.png
  %/Thumbnail%
%/PaymentLink%`

export const MESSAGE_SIMPLE_TEMPLATE = 'Olá! Sua fatura vence nos próximos 5 dias.'

export const MESSAGE_FILE_TEMPLATE = '%SendFile%%Filename%fatura.pdf%/Filename%%Url%https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf%/Url%%/SendFile%'

export const MESSAGE_FILE_AND_TEXT_TEMPLATE = 'Olá! Sua fatura já está disponível!%SendFile%%Filename%fatura.pdf%/Filename%%Url%https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf%/Url%%/SendFile%'

export const MESSAGE_SPLIT_TEMPLATE = '%NewLine%Olá! Sua fatura já está disponível!%/NewLine%%NewLine%Caso já tenha efetuado o pagamento, favor desconsiderar!%/NewLine%%NewLine%%SendFile%%Filename%fatura.pdf%/Filename%%Url%https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf%/Url%%/SendFile%%/NewLine%'